import { Box, Grid, InputAdornment, Paper, Typography } from "@mui/material";
import jwt_decode from 'jwt-decode';
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { REACT_EMAIL_REPORT } from "../../actions/EndPoints";
import CustomTextfeild from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import { addProduct, updateProducts } from "../../slices/EamilReport/EmailReportSlice";

function AddProductFormat(props) {
    const [emails, setEmails] = useState("");
    const [emailCount, setEmailCount] = useState(0);
    const maxEmails = 3;
    var decoded_jwtToken = jwt_decode(
        localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
    )
    const [payload, setPayload] = useState({
        adminEmail: decoded_jwtToken.user_name,
        wareHouseEmail: '',
        notifiers: [],
        wareHouseAddress: '',
        deliveryAdderss: ''
    })
    const dispatch = useDispatch();
    const history = useHistory();
    const [error, setError] = useState('')

    useEffect(() => {
        if (props.location.state != null) {
            setPayload({
                ...payload,
                id: props.location.state.id,
                adminEmail: props.location.state.adminEmail,
                wareHouseEmail: props.location.state.wareHouseEmail,
                notifiers: props.location.state.notifiers,
                wareHouseAddress: props.location.state.wareHouseAddress,
                deliveryAdderss: props.location.state.deliveryAdderss
            })
            setEmails(props.location.state.notifiers)
        }
    }, []);

    const handleSubmit = () => {
        if (props.location.state === undefined) {
            dispatch(addProduct(payload))
                .unwrap()
                .then((data) => {
                    if (data.code === "MSGS4078") {
                        Toast(data.message, "success");
                        history.push({
                            pathname: REACT_EMAIL_REPORT,
                            value: 1
                        });
                    } else {
                        Toast(data.message, "error");
                    }
                });
        } else {
            dispatch(updateProducts(payload))
                .unwrap()
                .then((data) => {
                    if (data.code === "MSGS4080") {
                        Toast(data.message, "success");
                        history.push({
                            pathname: REACT_EMAIL_REPORT,
                            value: 1
                        });
                    } else {
                        Toast(data.message, "error");
                    }
                });
        }

    }

    const handleCancel = () => {
        history.push({
            pathname: REACT_EMAIL_REPORT,
            value: 1
        });
    }

    const handleEmailsChange = (event) => {
        const inputEmails = event.target.value;
        setEmails(inputEmails);
        if (inputEmails.trim() === '') {
            setError('');
            setPayload((prevState) => ({
                ...prevState,
                notifiers: [],
            }));
            return;
        }
        const regex = /\S+@\S+\.\S+/;
        const emailArray = inputEmails.split(/[ ,;]+/).map(email => email.trim());
        let isValid = true;
        emailArray.forEach((email) => {
            if (!regex.test(email)) {
                isValid = false;
            }
        });
        if (emailArray.length > maxEmails) {
            Toast(`You can only add up to ${maxEmails} emails.`, 'error');
            return;
        }
        if (isValid) {
            setError('');
            setPayload((prevState) => ({
                ...prevState,
                notifiers: emailArray,
            }));
            setEmails(emailArray);
            setEmailCount(emailArray.length);
        } else {
            setError('Invalid email format', 'error');
        }
    }

    const handleChange = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        if (value === null) {
            setPayload({
                ...payload,
                [name]: ''
            })
        } else {
            setPayload({
                ...payload,
                [name]: value
            })
        }
    }

    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "column", height: "85vh" }}>
                <Box>
                    <HeaderToolbar
                        title={("Product Format Details")}
                        back_button={true}
                    />
                </Box>
                <Paper
                    style={{
                        flex: 1,
                        width: "100%",
                        Height: "100%",
                        backgroundColor: "#fff",
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                    }}
                >

                    <Grid
                        container
                        spacing={2}
                        style={{
                            padding: "16px",
                        }}
                    >
                        <Grid item xs={12} sm={6} md={4}>
                            <CustomTextfeild
                                label={"Admin Email"}
                                required={true}
                                validation="email"
                                value={payload.adminEmail}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <CustomTextfeild
                                label={"Warehouse Email"}
                                name="wareHouseEmail"
                                required={true}
                                validation="email"
                                value={payload.wareHouseEmail}
                                handleChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <CustomTextfeild
                                label={"Notifiers"}
                                variant="standard"
                                fullWidth
                                multiline
                                error={!!error}
                                helperText={error}
                                InputProps={{
                                    disableUnderline: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {emailCount}/{maxEmails}
                                        </InputAdornment>
                                    ),
                                }}
                                value={emails}
                                handleChange={handleEmailsChange}
                            />
                        </Grid>
                        <Grid item xs={6} sm={12}>
                            <CustomTextfeild
                                id="outlined-multiline-static"
                                label="Warehouse Address"
                                required={true}
                                multiline
                                rows={4}
                                value={payload.wareHouseAddress}
                                name="wareHouseAddress"
                                handleChange={handleChange}
                                inputProps={{ maxLength: 250 }}

                            />
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        style={{
                            padding: "16px",
                        }}
                    >
                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ '&:hover': { color: 'inherit' }, marginBottom: '5px' }}>Note:</Typography>
                            <Typography variant="body2">
                                1. Email will be sent from HQ.
                            </Typography>
                            <Typography variant="body2" style={{ marginTop: '5px' }}>
                                2. Notifiers will be copied.
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        justifyContent="flex-end"
                        style={{
                            padding: "16px",
                        }}
                    >
                        <Grid item>
                            <CancelButtons onClick={handleCancel}>
                                <Typography variant="body1" style={{ textTransform: "none" }}>
                                    {"Cancel"}
                                </Typography>
                            </CancelButtons>
                        </Grid>
                        <Grid item>
                            <SubmitButtons type="submit" onClick={handleSubmit} >
                                <Typography variant="body1" style={{ textTransform: "none" }}>
                                    {"Submit"}
                                </Typography>
                            </SubmitButtons>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </>
    )
}
export default AddProductFormat;